import { DKLabel, DKInput, DKCheckMark, Toggle, DKButton, TOAST_TYPE, showToast, removeLoader, showLoader, showAlert } from 'deskera-ui-library'
import moment from 'moment'
import { useEffect, useImperativeHandle, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { COMPANY_DATE_FORMATS, FORMAT, INPUT_TYPE } from '../../constants/Constant'
import { COLUMN_CODE } from '../../managers/TableManger'
import { fetchUsers, selectUsers } from '../../Redux/Slices/PayrollSlice'
import AttendanceService from '../../services/AttendanceService'
import EmployeeListService from '../../services/EmployeeListService'
import PayrollService from '../../services/PayrollService'
import PerformaceService from '../../services/PerformaceService'
import Utility, { deepClone } from '../../utility/Utility'
import { APPRAISAL_CYCLE_FORM_FIELD, APPRAISAL_FRQUENCY, APPRAISERS_FIELD, GOAL_FILTER, GOAL_FILTER_CONSTANT, GOAL_PRIORITY } from './PerformanceConstant';
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import AppraisalManager from './AppraisalManager'
import { useTranslation } from 'react-i18next'
import { async } from 'rxjs'
import MessageInfo from '../common/MessageInfo'
import { TENANT, TenantService } from '../../managers/TenantManagerService'
export default function AppraisalCycleDetails(props, ref) {
    
    const { t } = useTranslation();
    const filters = deepClone(GOAL_FILTER);
    let dataForEdit = null;
    const initialFormValues = {
        name: "",
        frequency: "",
        dueDate: "",
        description: "",
        hasSelfAssessmentPeriod: true,
        selfAssessmentStartDate: "",
        selfAssessmentDueDate: "",
        hasReportingManagers: false,
        reportingManagers: [],
        filter: filters[0],
        specificTeam: "",
        specificDesignation: "",
        applicableTo: []
    }
    const [formFields, setFormFields] = useState(deepClone(APPRAISAL_CYCLE_FORM_FIELD))
    const [formAppFields, setFormAppFields] = useState(deepClone(APPRAISERS_FIELD))
    const [formData, setFormData] = useState(initialFormValues)


    const [isEdit, setIsEdit] = useState(props.appraisalData ? true : false)
    const [appraisalDataForEdit, setDataFromProps] = useState(props.appraisalData ? props.appraisalData : null)
    const [canValidate, setCanValid] = useState(false)
    const [isDisabled, setIsDisabled] = useState((isEdit && props.appraisalData.appraiseeProgressCount) ? true:false )
    let teamData = [];
    let designations = [];
    let allUsers = [];
    /**Dispatch */
    const dispatch = useDispatch();
    const users = useSelector(selectUsers);

    
    useEffect(() => {
        let newFormData = formData;
        if (props.appraisalData) { // Edit case
            newFormData = updateDataForEdit(props.appraisalData)
            newFormData = getUsers(newFormData)
            
        } else {
            getUsers(newFormData)
        }

    }, [])
    useEffect(() => {
        if (formFields) {
            setFormFields(formFields)
        }
    }, [formFields])
    useEffect(() => {
        if (props.count > 0) {
            onNext();
        }
    }, [props.count]);
    const updateDataForEdit = (data) => {
        if (data) {
            dataForEdit = deepClone(data);
            let newData = deepClone(data)
            newData['selfAssessmentStartDate'] = data['selfAssessmentStartDate'] ? new Date(moment(data['selfAssessmentStartDate'], 'DD-MM-YYYY')) : null
            newData['selfAssessmentDueDate'] = data['selfAssessmentDueDate'] ? new Date(moment(data['selfAssessmentDueDate'], 'DD-MM-YYYY')) : null
            newData['dueDate'] = data['endDate'] ? new Date(moment(data['endDate'], 'DD-MM-YYYY')): null;
            delete newData.applicableTo
            delete newData.applicability
            delete newData.reportingManagers
            newData['frequency'] = APPRAISAL_FRQUENCY.find(g => g.id == (data.frequency.id || data.frequency));
            newData['filter'] = filters.find(g => g.id == (data?.applicability?.filter?.id || data?.applicability?.filter)) || filters[0];
            newData['specificDesignation'] = data?.applicability?.designation ?
                {
                    id: data?.applicability?.designation,
                    name: data?.applicability?.designation
                } : ''
            data = newData
        } else {
            data = initialFormValues
        }
        return data;
    }
    const getFieldValue = (obj) => {
        switch (obj.columnCode) {
            default:
                return formData[obj.columnCode]
        }
    }
    const onChange = (value, index, obj) => {
        if(isDisabled) {
            return
        }
        let newFormData = deepClone(formData);
        newFormData.dueDate = formData.dueDate;
        newFormData.selfAssessmentStartDate = formData.selfAssessmentStartDate;
        newFormData.selfAssessmentDueDate = formData.selfAssessmentDueDate;
        switch (obj.columnCode) {
            case 'hasSelfAssessmentPeriod':
                let alteredFields = [];
                alteredFields.push({ columnCode: "selfAssessmentStartDate", required: value, readOnly: !value })
                alteredFields.push({ columnCode: "selfAssessmentDueDate", required: value, readOnly: !value })
                EmployeeListService.getAlteredConfigDetails(formAppFields, alteredFields, false, {}, {});
                setFormAppFields(formAppFields);
                newFormData[obj.columnCode] = value;
                setFormData(newFormData)
                break;
            case 'hasReportingManagers':
                let altFields = [];
                altFields.push({ columnCode: "reportingManagers", required: value, readOnly: !value, options: users.users, isValid: value ? formAppFields.find(c=>c.columnCode === 'reportingManagers')?.isValid : true   })
                EmployeeListService.getAlteredConfigDetails(formAppFields, altFields, false, {}, {});
                
                newFormData[obj.columnCode] = value;
                if (!value) {
                    newFormData['reportingManagers'] = null;

                }
                setFormAppFields(formAppFields);
                setFormData(newFormData)
                break;
            case COLUMN_CODE.PEOPLE_PERFORMANCE_GOAL.FILTER:
                newFormData['specificTeam'] = '';
                newFormData['specificDesignation'] = '';
                newFormData[obj.key] = value;
                switch (value.id) {
                    case GOAL_FILTER_CONSTANT.SPECIFIC:
                        newFormData['applicableTo'] = [];
                        newFormData = getUsers(newFormData);
                        break;
                    case GOAL_FILTER_CONSTANT.DESIGNATION:
                        newFormData = getUserByDesignation(true, newFormData);
                        break;
                    case GOAL_FILTER_CONSTANT.TEAM:
                        newFormData = getUserByTeam(false, newFormData);
                        break;
                }

                break;
            case COLUMN_CODE.PEOPLE_PERFORMANCE_GOAL.DUE_DATE:
                
                newFormData[obj.columnCode] = new Date(value);
                newFormData = calCulateSelfAssismentDate(newFormData);
                setFormData(newFormData)
                break;
            case COLUMN_CODE.PEOPLE_PERFORMANCE_GOAL.FREQUENCY:
                newFormData[obj.columnCode] = value;
                newFormData = calCulateSelfAssismentDate(newFormData);
                setFormData(newFormData)
                break;
            default:
                if (obj.type == 'date') {
                    newFormData[obj.columnCode] = new Date(value);
                } else {
                    newFormData[obj.columnCode] = value;
                }

                setFormData(newFormData)
                break;
        }
    }
    const calCulateSelfAssismentDate=(newFormData)=>{
        if(!Utility.isEmpty(newFormData['frequency']?.id) && !Utility.isEmpty(newFormData['dueDate'])) {
            switch(newFormData['frequency'].id) {
                case 'QUARTERLY':
                    newFormData['selfAssessmentStartDate'] = moment(newFormData['dueDate']).subtract(3, 'months').toDate();
                    break;
                case 'HALF_YEARLY':
                    newFormData['selfAssessmentStartDate'] = moment(newFormData['dueDate']).subtract(6, 'months').toDate();
                    break;
                case 'YEARLY':
                    newFormData['selfAssessmentStartDate'] = moment(newFormData['dueDate']).subtract(12, 'months').toDate();
                    break;
            }
        }
        return newFormData;
    }
    const getUsers = async (newFormData) => {
        const isTeamSpecific = newFormData['filter'] && newFormData['filter'].id === GOAL_FILTER_CONSTANT.TEAM
        const isDesignationSpecific = newFormData['filter'] && newFormData['filter'].id === GOAL_FILTER_CONSTANT.DESIGNATION
        if (!Utility.isEmpty(users?.users)) {
            allUsers =  await dispatch(fetchUsers());
            allUsers = allUsers?.payload?.users || []
            

            let alteredConfig = [];

            alteredConfig.push({ columnCode: 'specificTeam', hidden: !isTeamSpecific, options: teamData })
            alteredConfig.push({ columnCode: 'specificDesignation', hidden: !isDesignationSpecific, options: designations })
            if (isTeamSpecific) {
                alteredConfig.push({ columnCode: 'applicableTo', options: allUsers, readOnly: false,hidden:true })
                let Config = []
                Config.push({ columnCode: 'reportingManagers', options: allUsers, readOnly: !newFormData.hasReportingManagers, hidden: false })
                Config.push({ columnCode: "selfAssessmentStartDate", required: newFormData['hasSelfAssessmentPeriod'], readOnly: !newFormData['hasSelfAssessmentPeriod'] })
                Config.push({ columnCode: "selfAssessmentDueDate", required: newFormData['hasSelfAssessmentPeriod'], readOnly: !newFormData['hasSelfAssessmentPeriod'] })
                EmployeeListService.getAlteredConfigDetails(formAppFields, Config, false)
                newFormData=getUserByTeam(true, newFormData)
            } else if (isDesignationSpecific) {
                
                let Config = []
                Config.push({ columnCode: 'reportingManagers', options: allUsers, readOnly: !newFormData.hasReportingManagers, hidden: false })
                Config.push({ columnCode: "selfAssessmentStartDate", required: newFormData['hasSelfAssessmentPeriod'], readOnly: !newFormData['hasSelfAssessmentPeriod'] })
                Config.push({ columnCode: "selfAssessmentDueDate", required: newFormData['hasSelfAssessmentPeriod'], readOnly: !newFormData['hasSelfAssessmentPeriod'] })
                EmployeeListService.getAlteredConfigDetails(formAppFields, Config, false)
                newFormData = getUserByDesignation(true, newFormData)
            } else {
                if (Utility.isEmpty(users?.users)) {
                    allUsers =  await dispatch(fetchUsers());
                    allUsers = allUsers?.payload?.users || []
                } else {
                    allUsers = users?.users || []
                }
                
                alteredConfig.push({ columnCode: 'applicableTo', options: allUsers, readOnly: false, hidden: false })
                
                let Config = []
                Config.push({ columnCode: 'reportingManagers', options: allUsers, readOnly: !newFormData.hasReportingManagers, hidden: false })
                Config.push({ columnCode: "selfAssessmentStartDate", required: newFormData['hasSelfAssessmentPeriod'], readOnly: !newFormData['hasSelfAssessmentPeriod'] })
                Config.push({ columnCode: "selfAssessmentDueDate", required: newFormData['hasSelfAssessmentPeriod'], readOnly: !newFormData['hasSelfAssessmentPeriod'] })
                EmployeeListService.getAlteredConfigDetails(formAppFields, Config, false)

                newFormData = setApplicableTo(allUsers, newFormData);
                EmployeeListService.getAlteredConfigDetails(formFields, alteredConfig, false)
                setFormFields([...formFields]);
                
            }
            
            setFormAppFields(formAppFields)
            setFormData(newFormData)
            return newFormData

        } else {

            const getUsersInternal = async (newFormData) => {
                const response = await dispatch(fetchUsers());

                if (response && response['error']) {
                    showToast((response['message'] ? response['message'] : "Unable to Load user."), TOAST_TYPE.FAILURE);

                }
                if (!Utility.isEmpty(users?.users)) {

                    allUsers = await dispatch(fetchUsers());
                    allUsers = allUsers.payload.users

                    let alteredConfig = [];

                    alteredConfig.push({ columnCode: 'specificTeam', hidden: !isTeamSpecific, options: teamData })
                    alteredConfig.push({ columnCode: 'specificDesignation', hidden: !isDesignationSpecific, options: designations })
                    if (isTeamSpecific) {
                        alteredConfig.push({ columnCode: 'applicableTo', options: allUsers, readOnly: false, hidden: true })
                        
                        newFormData = getUserByTeam(true, newFormData)
                    } else if (isDesignationSpecific) {
                        if (newFormData['specificDesignation'].id) {
                            const user = allUsers.filter(a => a.designation === newFormData['specificDesignation'].id)
                            alteredConfig.push({ columnCode: 'applicableTo', options: user, readOnly: false, hidden: true })
                        } else {
                            alteredConfig.push({ columnCode: 'applicableTo', options: allUsers, readOnly: false, hidden: true })

                        }
                        EmployeeListService.getAlteredConfigDetails(formFields, alteredConfig, false)
                        newFormData = getUserByDesignation(true, newFormData)
                    } else {
                        const users = allUsers
                        alteredConfig.push({ columnCode: 'applicableTo', options: users, readOnly: false, hidden: false })
                        allUsers = await dispatch(fetchUsers());
                        allUsers = allUsers.payload.users

                        newFormData = setApplicableTo(allUsers, newFormData);
                        EmployeeListService.getAlteredConfigDetails(formFields, alteredConfig, false)
                        
                    }
                    let Config = []
                    Config.push({ columnCode: 'reportingManagers', options: allUsers, readOnly: false, hidden: !newFormData.hasReportingManagers })
                    EmployeeListService.getAlteredConfigDetails(formAppFields, Config, false)
                }

                return newFormData
            }
            newFormData = await getUsersInternal(newFormData);
            setFormData(newFormData)
            return newFormData
        }
    }
    const setApplicableTo = (users, newFormData) => {
        if (dataForEdit) {
            let index = []
            dataForEdit?.applicability?.users?.forEach(a => {
                index.push(users?.findIndex(u => u.iamUserId == a))
            })
            newFormData.applicableTo = index
        }
        newFormData = setreportingManagers(users, newFormData)
        return newFormData
    }
    const setreportingManagers = (usersk, newFormData) => {
        const allUsers = users?.users || []
        if (dataForEdit && dataForEdit.reportingManagers) { //reportingManagers
            let index = []
            dataForEdit?.reportingManagers?.forEach(a => {
                index.push(allUsers?.findIndex(u => u.iamUserId == a))
            })
            newFormData.reportingManagers = index
        }
        return newFormData
    }
    const getUserByDesignation = async(isInit, newFormData) => {
        if (Utility.isEmpty(designations)) {
            showLoader()
            await AttendanceService.getDesignation().then(response => {
                removeLoader()
                if (response['designations']) {
                    designations = response['designations'].filter(res => res != "").map(d => {
                        return {
                            id: d,
                            name: d
                        }
                    });
                    newFormData = setApplicableToByDesignation(isInit, newFormData)
                }
            }, error => {
                removeLoader();
            })
        } else {
            newFormData = setApplicableToByDesignation(isInit, newFormData)
        }
        return newFormData
    }
    const setApplicableToByDesignation = (isInit, newFormData) => {

        let alteredConfig = [];

        alteredConfig.push({ columnCode: 'specificTeam', hidden: true })
        alteredConfig.push({ columnCode: 'specificDesignation', hidden: false, options: designations })
        
        allUsers = users?.users || []
        
        if (!isInit) {
            newFormData.applicableTo = [];
            alteredConfig.push({ columnCode: 'applicableTo', options: allUsers, readOnly: true, hidden: true })
        } else {
            newFormData['specificDesignation'] = designations?.find(g => g.id == (props.appraisalData?.applicability?.designation?.id || props.appraisalData?.applicability?.designation));

            const user = allUsers.filter(a => a.designation === newFormData['specificDesignation']?.id)
            alteredConfig.push({
                columnCode: 'applicableTo',
                options: allUsers,
                readOnly: false,
                hidden: true
            })
            setTimeout(() => {
                EmployeeListService.getAlteredConfigDetails(formFields, alteredConfig, false)
                newFormData = setApplicableTo(allUsers, newFormData);
                setFormData(newFormData)
                return newFormData
            }, 100)
        }
        let Config = []
                    Config.push({ columnCode: 'reportingManagers', options: allUsers, readOnly: !newFormData.hasReportingManagers })
                    EmployeeListService.getAlteredConfigDetails(formAppFields, Config, false)
        
        EmployeeListService.getAlteredConfigDetails(formFields, alteredConfig, false)
        
        if(!isInit) {
            setFormData(newFormData)
            setFormFields(formFields);
        }
        setFormAppFields(formAppFields)
        return newFormData
    }
    const getUserByTeam = async (isInit, newFormData) => {
        if (Utility.isEmpty(teamData)) {

            showLoader()
            const response = await PayrollService.getTeams();
            removeLoader()
            teamData = response?.teams?.map(t => {
                return {
                    ...t,
                    id: t.teamId,
                    members: t.members.map(m => {
                        return {
                            ...m,
                            name: m.firstName + " " + m.lastName
                        }
                    })
                }
            }) || []

        }

        let alteredConfig = [];

        alteredConfig.push({ columnCode: 'specificTeam', hidden: false, options: teamData })
        alteredConfig.push({ columnCode: 'specificDesignation', hidden: true, options: designations })

        
            allUsers = users?.users || []

        if (!isInit) {
            newFormData.applicableTo = [];
            alteredConfig.push({ columnCode: 'applicableTo', options: allUsers, readOnly: true, hidden: true })
        } else {
            if (props.appraisalData?.applicability?.teamId) {
                newFormData['specificTeam'] = teamData.find(g => g.id == props.appraisalData?.applicability?.teamId)
                setTimeout(() => {
                    newFormData = setApplicableTo(newFormData['specificTeam'].members, newFormData);
                    setFormData(newFormData)
                    return newFormData
                }, 100)
            }

            alteredConfig.push({ columnCode: 'applicableTo', options: newFormData['specificTeam']?.members || allUsers, readOnly: false, hidden: true })
        }
        let Config = []
                    Config.push({ columnCode: 'reportingManagers', options: allUsers, readOnly: !newFormData.hasReportingManagers })
                    EmployeeListService.getAlteredConfigDetails(formAppFields, Config, false)

        EmployeeListService.getAlteredConfigDetails(formFields, alteredConfig, false)
        if(!isInit) {
            setFormData(newFormData)
            setFormFields(formFields);
        }
        setFormAppFields(formAppFields)
        
        return newFormData
    }

    const prepareDataBeforeSubmit = () => {
        const user = formFields.find(f => f.columnCode === "applicableTo")
        let finalObject = {
            ...deepClone(formData),
            frequency: formData.frequency.id,
            dueDate: `${moment(formData.dueDate).format("DD-MM-YYYY")}`,
            startDate: `${moment(formData.startDate).format("DD-MM-YYYY")}`,
            selfAssessmentStartDate: formData.hasSelfAssessmentPeriod ? `${moment(formData.selfAssessmentStartDate).format("DD-MM-YYYY")}` : "",
            selfAssessmentDueDate: formData.hasSelfAssessmentPeriod ? `${moment(formData.selfAssessmentDueDate).format("DD-MM-YYYY")}` : "",
            applicability: {
                "filter": formData?.filter?.id,
                "teamId": formData?.specificTeam?.id,
                "designation": formData?.specificDesignation?.id,
                "users": formData?.filter?.id === GOAL_FILTER_CONSTANT.SPECIFIC ? formData.applicableTo.map(a => parseInt(user?.options[a]?.iamUserId)) || [] : []
            },
            reportingManagers: formData.hasReportingManagers && formData.reportingManagers ? formData.reportingManagers?.map(ind => parseInt(users.users[ind].iamUserId)) : [],
            questions: isEdit ? appraisalDataForEdit.questions?.sort((q1, q2) => q1.seq - q2.seq) : [
                {
                    "question": "",
                    "description": "",
                    "appraiser": true,
                    "selfAssessment": true
                },
                {
                    "question": "",
                    "description": "",
                    "appraiser": true,
                    "selfAssessment": true
                },
                {
                    "question": "",
                    "description": "",
                    "appraiser": true,
                    "selfAssessment": true
                }
            ]
        }
        delete finalObject.applicableTo;
        delete finalObject.filter;
        delete finalObject.specificDesignation;
        delete finalObject.specificTeam;
        delete finalObject.appraisalProgress
        delete finalObject.selfAssessmentProgress
        delete finalObject.status
        return finalObject;
    }
    const validateForm = () => {
        let isValid = true;

        formFields.filter(f => !f.hidden).forEach(field => {
            if (field.required && field.type != INPUT_TYPE.NUMBER && Utility.isEmpty(formData[field.key])) {
                isValid = false;
            } else if (field.required && field.type == INPUT_TYPE.NUMBER && Utility.isEmpty(formData[field.key].toString())) {
                isValid = false;
            } else if (!field.isValid) {
                isValid = false;
            }
        })

        formAppFields.filter(f => !f.hidden).forEach(field => {
            if (field.required && field.type != INPUT_TYPE.NUMBER && field.type != INPUT_TYPE.CHECKBOX && field.type != INPUT_TYPE.TOGGLE && Utility.isEmpty(formData[field.key])) {
                isValid = false;
            } else if (field.required && field.type == INPUT_TYPE.NUMBER && Utility.isEmpty(formData[field.key].toString())) {
                isValid = false;
            } else if (field.required && !field.isValid && field.type != INPUT_TYPE.CHECKBOX && field.type != INPUT_TYPE.TOGGLE) {
                isValid = false;
            }
        })

        return isValid
    }
    const onNext = () => {
        if(isDisabled) {
            props.onNext(AppraisalManager.getAppraisalData())
        } else {
            setCanValid(true);
            if (!validateForm()) {
                return;
            }

            let param = prepareDataBeforeSubmit();

            if (isEdit) {
                showLoader(t("UPDATING_PERFORMANCE_SETTINGS"));
                PerformaceService.updateAppraisalCycle(appraisalDataForEdit.id, param).then(
                    (response) => {
                        removeLoader();
                        showToast(t("UPDATE_PERFORMANCE_SETTINGS_SUCCESS"), TOAST_TYPE.SUCCESS);
                        AppraisalManager.setAppraisalData(response)
                        props.onNext(response)
                    }, (error) => {
                        removeLoader();
                        if (error?.errorMessage) {

                            showAlert('Appraisal can not be updated.', error.errorMessage)
                        } else {
                            showToast(t("INTERNAL_SERVER_ERROR"), TOAST_TYPE.FAILURE);
                        }

                    }
                );
            } else {
                showLoader(t("SAVING_PERFORMANCE_SETTINGS"));
                PerformaceService.saveAppraisalCycle(param).then(
                    (response) => {
                        removeLoader();
                        showToast(t("SAVE_PERFORMANCE_SETTINGS_SUCCESS"), TOAST_TYPE.SUCCESS);
                        AppraisalManager.setAppraisalData(response)
                        props.onNext(response)
                    }, (error) => {
                        removeLoader();
                        if (error?.errorMessage) {

                            showAlert('Appraisal already exists.', error.errorMessage)
                        } else {
                            showToast(t("INTERNAL_SERVER_ERROR"), TOAST_TYPE.FAILURE);
                        }

                    }
                );
            }
        }
        

    }
    const renderFields = (obj, index) => {
        return (
            <div className="web-width-50">
                <div className="p-h-s">
                    {(obj.type !== INPUT_TYPE.CHECKBOX && obj.type !== INPUT_TYPE.TOGGLE) && <DKInput

                        className={"p-v-s mb-r"}
                        icon={obj.icon}
                        title={obj?.name}
                        placeholder={obj?.name}
                        value={getFieldValue(obj)}
                        options={obj.options}
                        type={obj.type}
                        errorMessage={obj.errorMessage}
                        labelClassName=" text-align-left "
                        canValidate={canValidate || obj['canValidate']}
                        onChange={(value) => {
                            obj['canValidate'] = true;
                            try{
                                onChange(value, index, obj);
                            } catch(e) {
                                console.log(e)
                            }
                        }}
                        validator={(value) => {
                            if (obj.validation && obj.validation.regExp) {
                                const regex = new RegExp(obj.validation.regExp);
                                obj.isValid = regex.test(value);
                                return regex.test(value);
                            } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
                                obj.isValid = false
                                return false;
                            } else if (obj.required && Utility.isEmpty(value)) {
                                obj.isValid = false
                                return false;
                            } else if (obj.columnCode == 'selfAssessmentStartDate' && !Utility.isEmpty(formData["selfAssessmentDueDate"])) {
                                let field1 = moment(value);
                                let dob = moment(formData["selfAssessmentDueDate"]);
                                if (!Utility.isEmpty(field1) && moment(dob).isSameOrAfter(field1)) {
                                    obj.isValid = true;
                                    return true
                                } else {
                                    obj.isValid = false;
                                    return false
                                }
                            } else if (obj.columnCode == 'selfAssessmentDueDate' && !Utility.isEmpty(formData["selfAssessmentStartDate"])) {
                                let startDate = moment(formData["selfAssessmentStartDate"]).startOf('day');
                                let dueDate = moment(formData["dueDate"]).endOf('day');
                                let dob = moment(value);
                                if ( !Utility.isEmpty(startDate) && !Utility.isEmpty(dueDate) && moment(dob).isBetween(startDate,dueDate)) {
                                    obj.isValid = true;
                                    return true
                                } else {
                                    obj.isValid = false;
                                    return false
                                }
                            } else if(obj.columnCode == 'dueDate' && !Utility.isEmpty(value)) {
                                if (moment(value).startOf("day").isBefore(moment(new Date()).startOf("day"))) {
                                    obj.isValid = false;
                                    return false
                                } else if(!Utility.isEmpty(value)) {
                                    obj.isValid = true;
                                    return true;
                                }
                            }else {
                                obj.isValid = true;
                                return true;
                            }
                        }}
                        formatter={(obj) => {
                            /** How to render a selected option in case of object **/
                            return obj?.name;
                        }}
                        displayKey={"name"}
                        dropdownConfig={{
                            className: "",
                            checkMarkColor: "bg-app",
                            style: {},
                            searchableKey: "name",
                            allowSearch: obj.options?.length > 6 ? true : false,
                            multiSelect: obj.multiSelect,
                            data: obj.options,
                            renderer: (index, obj) => {
                                /** How to render value in Dropdown in case of object **/
                                return <DKLabel text={`${obj?.name}`} />;
                            },
                            onSelect: (index, obj) => {

                            },
                        }}
                        direction={obj.direction}
                        required={obj.required}
                        readOnly={obj.readOnly || isDisabled}
                        dateFormat={COMPANY_DATE_FORMATS.filter(c => c.label == TenantService.get(TENANT.DATE_FORMAT))[0]?.value}
                    />}
                    {obj.type === INPUT_TYPE.CHECKBOX && (
                        <div className="row" style={{ height: 78 }}>
                            <div onClick={() => onChange(!getFieldValue(obj), index, obj)} >
                                <DKCheckMark
                                    isSelected={getFieldValue(obj)}
                                    color={isDisabled ? "bg-gray cursor-not-allowed":"bg-app"}
                                />
                            </div>
                            <DKLabel className="ml-s" text={obj.name} />
                        </div>
                    )}
                    {obj.type === INPUT_TYPE.TOGGLE && (
                        <div className="row pt-s" style={{ height: 78 }}>
                            <DKLabel
                                className="text-align-left ml-s mr-l"
                                text={obj.name}
                            />
                            <Toggle
                                className={`${isDisabled? "cursor-not-allowed":"cursor-pointer" } border-n`}
                                isOn={getFieldValue(obj)}
                                onChange={() => {
                                    onChange(!getFieldValue(obj), index, obj)
                                }}
                            />
                            <DKLabel
                                className="text-align-left ml-l mr-l fw-m"
                                text={obj.secondoryName}
                            />
                        </div>
                    )}
                </div>
            </div>
        )
    }
    const renderForm = () => {
        try {
            return formFields.filter(f => !f.hidden).map((f, i) => renderFields(f, i))
        } catch (error) {
            return ''
        }
    }
    const renderAppraisersForm = () => {

        return formAppFields.filter(f => !f.hidden).map((f, i) => renderFields(f, i))
    }
    const getAppraisalCycle = () => {
        return <div className="p-l d-flex" style={{ flexWrap: 'wrap' }}>
            {renderForm()}
        </div>
    }
    const getAppraisers = () => {
        return <div className="p-l d-flex" style={{ flexWrap: 'wrap' }}>
            {renderAppraisersForm()}
        </div>
    }
    return <>
        <div className="bg-white border-m border-radius-s">
            <DKLabel className="fw-m fs-m p-h-l pt-l" text={`${isEdit ? "Edit" : "Add"} appraisal cycle details`} />

            {getAppraisalCycle()}
            <DKLabel className="fw-m fs-m p-h-l pt-l" text="Select Appraisers:" />
            <MessageInfo
                    message={[{ message: t("SELF_ASSESSMENT_TEXT1") }]}
                    bannerClass=" p-h-xl pt-l"
                    isClosable={true}
                />
            {getAppraisers()}
        </div>
        <div className="row mt-m">
            <DKButton className="bg-app text-white" title="Next" onClick={() => { onNext() }} />
            <DKButton className="bg-white border-m ml-m" title="Cancel" onClick={() => props.onCancel()} />
        </div>
    </>
}